import React, { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';
import { COOKIE_SETTINGS_EVENT, CONSENT_EVENT, getConsent, saveConsent } from '../lib/analytics';
import './CookieConsent.css';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(() => !getConsent());
  useEffect(() => {
    const open = () => setVisible(true);
    const close = () => setVisible(false);
    window.addEventListener(COOKIE_SETTINGS_EVENT, open);
    window.addEventListener(CONSENT_EVENT, close);
    return () => {
      window.removeEventListener(COOKIE_SETTINGS_EVENT, open);
      window.removeEventListener(CONSENT_EVENT, close);
    };
  }, []);

  if (!visible) return (
    <button type="button" className="cookie-settings-button" data-testid="cookie-settings-button"
      onClick={() => setVisible(true)} aria-label="Cookie-instellingen" title="Cookie-instellingen">
      <Cookie size={20} />
    </button>
  );

  return (
    <section className="cookie-consent" data-testid="cookie-consent-banner" aria-label="Cookievoorkeuren">
      <div className="cookie-consent-copy">
        <strong data-testid="cookie-consent-title">Uw privacy, uw keuze</strong>
        <p data-testid="cookie-consent-description">IMPERIA AI meet websitegebruik direct zonder analytics- of advertentiecookies. Met uw toestemming gebruiken we aanvullende statistiek- en marketingcookies. U kunt uw cookiekeuze altijd wijzigen.</p>
      </div>
      <div className="cookie-consent-actions">
        <Button variant="outline" data-testid="cookie-reject-button" onClick={() => saveConsent(false, false)}>Geen optionele cookies</Button>
        <Button variant="outline" data-testid="cookie-analytics-button" onClick={() => saveConsent(true, false)}>Statistieken toestaan</Button>
        <Button data-testid="cookie-accept-all-button" onClick={() => saveConsent(true, true)}>Alles toestaan</Button>
      </div>
    </section>
  );
};